//BOOTSTRAP
import "bootstrap/dist/css/bootstrap.min.css"
//BOOTSTRAP ICONS
import 'bootstrap-icons/font/bootstrap-icons.css';
//LEAFLET
import 'leaflet/dist/leaflet.css';
//FONTAWESOME FROG ICON
import '@fortawesome/fontawesome-free/css/all.css';
//ROUTER
import router from './router/router';
//STORE
import store from './store/store';

import { createApp } from 'vue';
import App from './App.vue';
import axios from 'axios';

// Globale request interceptor om automatisch Bearer token + App-Key toe te voegen.
axios.interceptors.request.use(config => {
  // Als expliciet headers meegegeven zijn in een call (bv. store actions) laten we die staan,
  // maar injecteren we ontbrekende Authorization / App-Key indien beschikbaar.
  const token = localStorage.getItem('hopstats-auth-token');
  const type = localStorage.getItem('hopstats-auth-type') || 'Bearer';
  const appKeyName = localStorage.getItem('hopstats-app-key-name');
  const appKeyValue = localStorage.getItem('hopstats-app-key-value');

  if (!config.headers) config.headers = {};
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `${type} ${token}`;
  }
  if (appKeyName && appKeyValue && !config.headers[appKeyName]) {
    config.headers[appKeyName] = appKeyValue;
  }
  return config;
});

// Globale response interceptor voor 401 -> force logout.
axios.interceptors.response.use(response => response, error => {
  if (error && error.response && error.response.status === 401) {
    // Tokens verwijderen en redirect naar login.
    ['hopstats-auth-token','hopstats-auth-type','hopstats-auth-expires','hopstats-app-key-name','hopstats-app-key-value','hopstats-user-role','hopstats-stay-logged-in']
      .forEach(k => localStorage.removeItem(k));
    // Eventueel oude keys ook opruimen.
    ['hopstats-api-key-name','hopstats-api-key','hopstats-api-key-expiry']
      .forEach(k => localStorage.removeItem(k));
    if (router.currentRoute.value.path !== '/aanmelden') {
      router.push('/aanmelden');
    }
  }
  return Promise.reject(error);
});

createApp(App).use(router).use(store).mount('#app')

import "bootstrap/dist/js/bootstrap.js"
